export function House() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="currentcolor"
    >
      <path d="M23.9927 11.9766C23.9927 12.8203 23.3676 13.4813 22.6593 13.4813H21.3259L21.3551 20.9859C21.3551 21.1172 21.3467 21.2391 21.3342 21.3656V22.125C21.3342 23.1609 20.5884 24 19.6675 24H19.0008C18.955 24 18.9091 23.9578 18.8633 23.9953C18.8049 23.9578 18.7466 24 18.6883 24H16.334C15.4131 24 14.6673 23.1609 14.6673 22.125V18C14.6673 17.1703 14.0714 16.5 13.3339 16.5H10.6671C9.92958 16.5 9.33372 17.1703 9.33372 18V22.125C9.33372 23.1609 8.58786 24 7.66698 24H5.33772C5.27522 24 5.21272 23.9953 5.15021 23.9906C5.10021 23.9953 5.05021 24 5.00021 24H4.33351C3.41306 24 2.66678 23.1609 2.66678 22.125V16.875C2.66678 16.8328 2.66803 16.7859 2.67053 16.7438V13.4813H1.33547C0.584191 13.4813 0 12.8203 0 11.9766C0 11.5547 0.125172 11.1797 0.417101 10.8516L11.1005 0.37575C11.3921 0.0469687 11.7255 0 12.0172 0C12.3088 0 12.6422 0.0939375 12.8964 0.328781L23.5343 10.8516C23.8677 11.1797 24.0385 11.5547 23.9927 11.9766Z" />
    </svg>
  );
}
